import { useContext } from 'react';
import { CartIdContext } from '../Cart/CartIdContext';
import { useQuery } from '@apollo/react-hooks';
import throwErrorInDev from '../../helpers/throwErrorInDev';
export function useCart(cartQuery) {
    const { cartId } = useContext(CartIdContext);
    const result = useQuery(cartQuery, {
        ssr: false,
        variables: { cartId }
    });
    return { result, cart: result.data && result.data.cart };
}
export default function CartProvider({ children, query }) {
    throwErrorInDev(!query, `You forgot to pass 'query' to CartProvider`);
    const { result } = useCart(query);
    if (!result.data || (result.data && !result.data.cart)) {
        result.data = {};
        result.data.cart = null;
    }
    return children(result);
}
//# sourceMappingURL=CartProvider.js.map